import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center px-5">
      <div className="grain-overlay" />
      <div
        data-testid="payment-cancel-page"
        className="relative max-w-lg w-full border border-white/15 bg-gradient-to-b from-white/[0.04] to-transparent p-10 md:p-14 text-center"
      >
        <XCircle className="h-8 w-8 text-muted-foreground mx-auto" />
        <h1 className="mt-6 font-serif text-5xl leading-[0.9] tracking-tighter text-bone">
          Checkout <span className="italic">cancelled</span>
        </h1>
        <p className="mt-5 text-sm md:text-base text-muted-foreground leading-relaxed">
          No charge was made. The vault's still here whenever you're ready —
          it's only two dollars.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-home"
          className="mt-9 inline-flex items-center justify-center gap-2 bg-blood text-white px-7 py-3.5 font-mono text-[11px] tracking-[0.25em] uppercase transition-transform duration-300 hover:-translate-y-0.5"
        >
          Back to Old Geezer
        </Link>
      </div>
    </div>
  );
}
